export default "__VITE_ASSET__BpS_gaD0__"